import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Lohsa, Lausitz
const LAT = 51.3833;
const LNG = 14.4000;

export default function LocationMap({ testId = "location-map", zoom = 11, height = "100%" }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;

    const map = L.map(containerRef.current, {
      center: [LAT, LNG],
      zoom,
      scrollWheelZoom: false,
      attributionControl: true,
    });
    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution:
        '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    // Custom large red pin as a DivIcon (drop-pin shape with subtle pulse)
    const pinHtml = `
      <div class="taeste-pin" aria-label="Standort Lohsa">
        <span class="taeste-pin__pulse"></span>
        <svg viewBox="0 0 32 44" width="32" height="44" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 0C7.2 0 0 7.2 0 16c0 11.5 14.4 26.4 15 27 .5.6 1.5.6 2 0 .6-.6 15-15.5 15-27C32 7.2 24.8 0 16 0z"
                fill="hsl(8 75% 46%)" stroke="hsl(8 65% 32%)" stroke-width="1.5"/>
          <circle cx="16" cy="16" r="5.5" fill="#fff" />
        </svg>
      </div>
    `;
    const icon = L.divIcon({
      html: pinHtml,
      className: "taeste-pin-wrapper",
      iconSize: [32, 44],
      iconAnchor: [16, 44],
      popupAnchor: [0, -40],
    });
    L.marker([LAT, LNG], { icon, title: "Tæste · 02999 Lohsa · Lausitz" })
      .addTo(map)
      .bindPopup("Tæste · 02999 Lohsa · Lausitz");

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [zoom]);

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      style={{ width: "100%", height }}
      className="bg-[hsl(var(--secondary))]"
    />
  );
}
